import styled from "styled-components";
import { Button } from "antd";

export const StyledMainButton = styled(Button)`
    background-color: ${props => props.type === "primary" && "#ed1c24"};
    width: 138px;
    height: 39.77px;
    font-size: 16px;
    box-shadow: none;
    border: ${props => props.type === "default" && "1px solid #ed1c24"};
    color: ${props => props.type === "default" && "#ed1c24"};
    &:hover {
        background-color: ${props => props.type === "primary" && "#e74a50 !important" || props.type === "default" && "#f7ddddd9 !important"};
        color: ${props => props.type === "primary" && "#fff" || props.type === "default" && "#ed1c24 !important"};
        border: ${props => props.type === "default" && "1px solid #e74a50 !important"};
    }

    ${props => props?.children?.toString().toLocaleLowerCase().includes("iptal") && `
        background-color: #e4e7ed;
        color: #8b8b8b;
        border: 1px solid #8b8b8b;
        &:hover {
            background-color: #8b8b8b !important;
            color: #e4e7ed !important;
            border: 1px solid #e4e7ed !important;
        }
    `}

`;